import { useMutation, useQuery } from "@tanstack/react-query"
import axios from "axios"
import { checkForAuthorization } from "utilities/index"
import { RetryOnError, verifyToken } from "utilities/VerifyToken"

export const FetchAllResources = (startup_id) => {
    return useQuery(
        ['FetchAllResources-FetchAllResources-FetchAllResources-fetch-all', startup_id],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/resources?startup_id=${startup_id}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                }
            })
        }, {
        select: (data) => {
            return data?.data?.data || []
        },
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
    })
}

export const FetchResourceById = (startup_id, resource_id) => {
    return useQuery(
        ['FetchResourceById-FetchResourceById-fetch', startup_id, resource_id],
        () => {
            return axios({
                method: 'get',
                url: `${process.env.REACT_APP_BASE_URL}/resources/get-resource/${startup_id}/${resource_id}`,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                }
            })
        }, {
        select: (data) => {
            return data?.data?.data || {}
        },
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
            return RetryOnError(failureCount, error)
        },
        onError: (err) => {
            return verifyToken(err)
        },
        enabled: !!resource_id
    })
}

export const UnlockResource = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/resources/unlock-resource`,
                data: payload,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                }
            })
        },
        {
            onError: (err) => {
                return verifyToken(err)
            },
        }
    )
}

export const SubmitResourceFeedback = () => {
    return useMutation(
        (payload) => {
            return axios({
                method: 'post',
                url: `${process.env.REACT_APP_BASE_URL}/resources/submit-feedback`,
                data: payload,
                headers: {
                    Authorization: `Bearer ${checkForAuthorization()}`,
                }
            })
        },
        {
            onError: (err) => {
                return verifyToken(err)
            },
        }
    )
}
